import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformCustomCoverMutation } from "../graphql/mutations";
import type {
  UpdatePlatformCustomCoverMutationType,
  UpdatePlatformCustomCoverMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePlatformCustomCoverMutation = (
  options?: MutationHookOptions<
    UpdatePlatformCustomCoverMutationType,
    UpdatePlatformCustomCoverMutationVariablesType
  >
) => {
  return useMutation<
    UpdatePlatformCustomCoverMutationType,
    UpdatePlatformCustomCoverMutationVariablesType
  >(UpdatePlatformCustomCoverMutation, options);
};
